export const convertToKebabCase = (name) => {
    return name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};
export const upperCaseFirstLetter = (input) => {
    return input.charAt(0).toUpperCase() + input.slice(1);
};
const wordsRegex = /[A-Za-z][a-z]*|[0-9]+/g;
export const convertToCamelCase = (input) => {
    const words = input.match(wordsRegex) || [];
    return words.reduce((acc, word, index) => {
        const lowerWord = word.toLowerCase();
        return acc + (index === 0 ? lowerWord : upperCaseFirstLetter(lowerWord));
    }, '');
};
export const convertToPascalCase = (input) => {
    const words = input.match(wordsRegex) || [];
    return words.reduce((acc, word) => {
        const lowerWord = word.toLowerCase();
        return acc + upperCaseFirstLetter(lowerWord);
    }, '');
};
/**
 * Validate string is empty or whitespace
 */
export const isEmptyOrWhitespace = (input) => {
    return input.trim().length === 0;
};
/**
 * Removes extra whitespace characters from a string
 */
export const normaliseWhitespace = (input) => {
    return input.trim().replace(/\s+/g, ' ');
};
export const areStringsTheSameOrUndefined = (...values) => {
    const filteredValues = values.filter(value => value !== undefined);
    const value = filteredValues[0];
    return filteredValues.every(v => v === value);
};
